<template>
  <div class="content">
    <div class="row">
      <div class="col-sm-6">
        <ArtistSelect
          class="artist-selection"
          @memberChangeEvent="getArtistInfo"
          :is-filter="true"
          :include-unit-artist="true"
          :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
          :initial-member-id="$route.query.artistId ? parseInt($route.query.artistId, 10) : null"
        />
      </div>
      <div class="col-sm-3">
        <h4 class="card-title text-left">상태</h4>
        <div class="row">
          <div class="col-sm-12">
            <el-select class="select-primary" size="large" placeholder="멤버선택" v-model="state" @change="getData(1)">
              <el-option v-for="option in states" class="select-primary" :value="option.value" :label="option.label" :key="option.label"></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <form class="form-horizontal">
      <card class="text-left">
        <template slot="header">
          <h4 class="card-title">아티스트보드 제안</h4>
        </template>
        <div class="row">
          <el-table :data="data">
            <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
            <el-table-column v-if="state === 1" :min-width="50" align="right" label="숨김">
              <div slot-scope="props">
                <base-button @click.native.stop="hideSuggestion(props.row)" class="edit btn-minus" type="warning" size="sm" icon>
                  <i class="tim-icons icon-minus" />-
                </base-button>
              </div>
            </el-table-column>
            <el-table-column :min-width="50" align="right" label="알림보내기">
              <div slot-scope="props">
                <base-button @click.native.stop="sendNotification(props.row)" class="edit btn-link" type="warning" size="sm" icon>
                  <i class="tim-icons icon-send" />
                </base-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div class="row">
          <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
        </div>
      </card>
      <base-button native-type="submit" type="success">등록</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
    </form>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import { BasePagination, Card } from "@/components/index";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { URLUtils } from "@/util/URLUtils";
import swal from "sweetalert2";
import { ReportState } from "@/pages/Reports/ReportState";
import handlebars from "handlebars";
import { formatDateTime } from "@/util/DateUtils";

export default {
  components: {
    ArtistSelect,
    Card,
    BasePagination,
  },

  async created() {},
  data() {
    return {
      state: ReportState.SUBMITTED,
      states: [
        { label: "접수", value: ReportState.SUBMITTED },
        { label: "숨김", value: ReportState.REJECTED },
        { label: "반영", value: ReportState.APPROVED },
      ],
      currentPage: 1,
      totalPages: null,
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50,
        },
        {
          prop: "userInfo",
          label: "유저아이디",
          minWidth: 50,
        },
        {
          prop: "unitName",
          label: "아티스트",
          minWidth: 50,
        },
        {
          prop: "memberName",
          label: "멤버",
          minWidth: 50,
        },
        {
          prop: "category",
          label: "카테고리",
          minWidth: 50,
        },
        {
          prop: "message",
          label: "내용",
          minWidth: 150,
        },
        {
          prop: "source",
          label: "출처",
          minWidth: 150,
        },
        {
          prop: "regTime",
          label: "작성일",
          minWidth: 50,
        },
      ],
      categories: [
        {
          id: 1,
          category: "특기",
        },
        {
          id: 2,
          category: "취미",
        },
        {
          id: 3,
          category: "별명",
        },
        {
          id: 4,
          category: "기타",
        },
        {
          id: 5,
          category: "MBTI",
        },
      ],
      unitId: null,
      unitName: null,
      memberId: null,
      data: [],
      notification: {
        title: `[{{unitName}}] 덕분에 블립이 더욱 똑똑해졌어요 🤓`,
        message: `업데이트된 아티스트의 정보를 확인해보세요`,
        memberIds: [],
      },
      members: {
        options: [],
      },
    };
  },
  watch: {
    currentPage: {
      handler() {
        this.getData(this.currentPage);
      },
    },
  },
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      this.memberId = param.memberId;
      this.unitName = param.unitName;
      await this.getData();
    },

    async getData(page) {
      const currentPage = page ? page : 1;
      const queryParams = {
        unitId: this.unitId,
        artistId: this.memberId || undefined,
      };
      const path = `/artistBoard/artistBoardSuggestion?${URLUtils.objectToQueryString(queryParams)}`;
      if (this.$route.fullPath !== path) {
        try {
          await this.$router.push(path);
        } catch (ex) {}
      }
      return this.$axios
        .get("/artistBoard/suggestions", {
          params: { unitId: this.unitId, memberId: this.memberId, state: this.state, currentPage },
        })
        .then((res) => {
          this.data = res.data.data.data.map((d) => {
            d.category = this.categories.filter((c) => c.id === d.categoryId)[0].category;
            d.regTime = formatDateTime(d.regTime);
            d.userInfo = `${d.nickname}(${d.userId})`;
            return d;
          });
          this.totalPages = Number(res.data.data.page);
        });
    },
    async hideSuggestion(row) {
      return this.$axios
        .put(`/artistBoard/suggestions/state`, {
          params: {
            id: row.id,
            state: ReportState.REJECTED,
          },
        })
        .then((res) => {
          Toast.success("숨김처리되었습니다");
          this.currentPage = 1;
          this.getData(1);
        });
    },
    async sendNotification(row) {
      swal
        .fire({
          title: "알림 전송 확인",
          text: `아티스트보드 반영 알림을 전송하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-danger btn-fill",
          cancelButtonClass: "btn btn-cancel btn-fill",
          confirmButtonText: "전송",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              const titleTemplate = handlebars.compile(this.notification.title, { noEscape: true });
              this.notification.title = titleTemplate({
                unitName: row.unitName,
              });
              return this.$axios
                .put(`/artistBoard/suggestions/notification`, {
                  params: {
                    id: row.id,
                    state: ReportState.APPROVED,
                    title: this.notification.title,
                    message: this.notification.message,
                    userId: row.userId,
                    unitId: row.unitId,
                    artistId: row.memberId,
                  },
                })
                .then((res) => {
                  Toast.success("전송완료");
                  this.currentPage = 1;
                  this.getData(1);
                });
            } catch (err) {
              Toast.error("알림 전송 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    goBack() {
      history.go(-1);
    },
  },
};
</script>
<style scoped lang="scss">
.artist-selection {
  margin-bottom: 20px;
}
.dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}
.dropzone {
  padding: 0px;
}
.dz-image {
  height: 80% !important;
}
.dz-message {
  margin: 0em !important;
}

.subtitle {
  font-size: 13px;
  color: #314b5f;
}
</style>
